import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BrandLogoEntity, BrandLogoEntityRaw } from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  RoomBrandLogoCreateRequestDTO,
  RoomBrandLogoCreateResponseDTO,
  RoomBrandLogoDeleteRequestDTO,
  RoomBrandLogoDeleteResponseDTO,
  RoomBrandLogoUnUseRequestDTO,
  RoomBrandLogoUseRequestDTO
} from "../dto";

@Injectable()
export class RoomBrandLogoService {
  constructor(private readonly apiService: ApiService) {}

  roomBrandLogoCreate(
    roomBrandLogoCreateRequestDTO: RoomBrandLogoCreateRequestDTO
  ): Observable<RoomBrandLogoCreateResponseDTO> {
    const formData = new FormData();

    formData.set("logo", roomBrandLogoCreateRequestDTO.data.data);
    formData.set("width", roomBrandLogoCreateRequestDTO.data.width + "");
    formData.set("height", roomBrandLogoCreateRequestDTO.data.height + "");

    return this.apiService
      .post<{ brandLogo: BrandLogoEntityRaw }>(
        `rooms/${roomBrandLogoCreateRequestDTO.data.roomId}/brands/${roomBrandLogoCreateRequestDTO.data.brandId}/logos`,
        formData,
        "v1",
        new HttpHeaders().set("Content-Type", "multipart/form-data")
      )
      .pipe(
        map(
          (_) =>
            new RoomBrandLogoCreateResponseDTO({
              brandLogo: new BrandLogoEntity(_.brandLogo)
            })
        )
      );
  }

  roomBrandLogoDelete(
    roomBrandLogoDeleteRequestDTO: RoomBrandLogoDeleteRequestDTO
  ): Observable<RoomBrandLogoDeleteResponseDTO> {
    return this.apiService
      .delete(
        `rooms/${roomBrandLogoDeleteRequestDTO.data.roomId}/brands/${roomBrandLogoDeleteRequestDTO.data.brandLogo.value.brandId}/logos/${roomBrandLogoDeleteRequestDTO.data.brandLogo.value.id}`
      )
      .pipe(
        map(
          () =>
            new RoomBrandLogoDeleteResponseDTO({
              roomId: roomBrandLogoDeleteRequestDTO.data.roomId,
              brandLogo: roomBrandLogoDeleteRequestDTO.data.brandLogo
            })
        )
      );
  }

  roomBrandLogoUnUse(
    roomBrandLogoUnUseRequestDTO: RoomBrandLogoUnUseRequestDTO
  ): Observable<void> {
    return this.apiService.delete<void>(
      `rooms/${roomBrandLogoUnUseRequestDTO.data.roomId}/brands/${roomBrandLogoUnUseRequestDTO.data.brandLogo.value.brandId}/logos/${roomBrandLogoUnUseRequestDTO.data.brandLogo.value.id}/use`
    );
  }

  roomBrandLogoUse(
    roomBrandLogoUseRequestDTO: RoomBrandLogoUseRequestDTO
  ): Observable<void> {
    return this.apiService.post<void>(
      `rooms/${roomBrandLogoUseRequestDTO.data.roomId}/brands/${roomBrandLogoUseRequestDTO.data.brandLogo.value.brandId}/logos/${roomBrandLogoUseRequestDTO.data.brandLogo.value.id}/use`,
      {}
    );
  }
}
